module.exports = __webpack_public_path__ + "img/TruckIcon.c6780e0d.svg";